var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSatisfied(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "304.56px",
    height: "261.39px",
    viewBox: "0 0 304.56 261.39",
    enableBackground: "new 0 0 304.56 261.39",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CDDFE3",
    d: "M62.74,240.49c52.19,23.53,110.35,19.31,158.61-7.38s86.14-63.9,74.91-133.73 C285.04,29.55,173.45-17.04,102.35,17.06C17.57,57.72-49.34,189.97,62.74,240.49z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#868B90",
    d: "M84.51,208.29c36.31,15.81,76.95,12.54,110.84-6.09s60.58-44.42,53.19-92.29 c-7.39-47.87-85.04-79.12-134.93-55.26C54.13,83.11,6.54,174.33,84.51,208.29z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 759.0708,
    cy: -5.6811,
    r: 138.8372,
    gradientTransform: "matrix(0.8041 -0.5945 0.5404 0.7309 -462.205 588.2203)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4A9AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AAAEB2",
      stopOpacity: 0.0296
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M84.51,208.29c36.31,15.81,76.95,12.54,110.84-6.09s60.58-44.42,53.19-92.29 c-7.39-47.87-85.04-79.12-134.93-55.26C54.13,83.11,6.54,174.33,84.51,208.29z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 759.0708,
    cy: -5.6811,
    r: 100.3507,
    gradientTransform: "matrix(0.9165 -0.4 0.3262 0.7474 -548.7498 440.6913)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4C8CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6534,
    style: {
      stopColor: "#C2C6CA",
      stopOpacity: 0.3466
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9682,
    style: {
      stopColor: "#BAC0C3",
      stopOpacity: 0.0318
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B9BFC2",
      stopOpacity: 0
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M84.51,208.29c36.31,15.81,76.95,12.54,110.84-6.09s60.58-44.42,53.19-92.29 c-7.39-47.87-85.04-79.12-134.93-55.26C54.13,83.11,6.54,174.33,84.51,208.29z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 759.0708,
    cy: -5.6811,
    r: 77.6615,
    gradientTransform: "matrix(0.9165 -0.4 0.3262 0.7474 -548.7498 440.6913)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#DDE2E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M84.51,208.29c36.31,15.81,76.95,12.54,110.84-6.09s60.58-44.42,53.19-92.29 c-7.39-47.87-85.04-79.12-134.93-55.26C54.13,83.11,6.54,174.33,84.51,208.29z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M87.73,185.7c-1.97,0-3.93-0.77-5.41-2.3c-2.87-2.99-2.78-7.73,0.21-10.6l33.69-32.41 c0.17-0.17,0.06-0.46-0.19-0.46h-46.6c-4.13,0-7.74-3.18-7.84-7.3c-0.11-4.23,3.29-7.7,7.5-7.7l66.03,0c2.26,0,4.47,0.89,5.92,2.63 c2.64,3.17,2.25,7.61-0.51,10.28l-47.59,45.78C91.48,185.01,89.6,185.7,87.73,185.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M232.45,125.73c1.23-1.37,1.88-3.25,1.66-5.3c-0.43-3.99-4.03-7.1-8.03-6.93l-45.16,1.83 c-0.23,0.01-0.38-0.27-0.23-0.44l29.08-32.45c2.57-2.87,2.46-7.51-0.54-10.34c-3.08-2.9-7.78-2.85-10.41,0.08l-41.2,45.98 c-1.41,1.57-2.13,3.71-1.74,5.87c0.71,3.96,4.26,6.65,7.98,6.5l63.78-2.59C229.59,127.88,231.28,127.04,232.45,125.73z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 363.1098,
    y1: 256.0195,
    x2: 365.0588,
    y2: 223.6037,
    gradientTransform: "matrix(1.1844 -0.4545 0.5316 1.3853 -393.9898 -1.219)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#404749"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    style: {
      stopColor: "#313537"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#181818"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M138.2,158.2l42.3-16.23c3.04-1.17,6.6,1.09,7.48,4.79c2.67,11.21,4.97,32.9-14.43,40.34 s-32.2-10.22-37.71-20.33C134.02,163.43,135.16,159.37,138.2,158.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B2226",
    d: "M107.33,139.93H78.02c-4.14,0-7.5-3.36-7.5-7.5v0c0-4.14,3.36-7.5,7.5-7.5h29.31c4.14,0,7.5,3.36,7.5,7.5v0 C114.83,136.57,111.47,139.93,107.33,139.93z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B2226",
    d: "M111.05,166.14l-12.01,11.58c-2.98,2.87-7.73,2.79-10.6-0.19h0c-2.87-2.98-2.79-7.73,0.19-10.6l12.01-11.58 c2.98-2.87,7.73-2.79,10.6,0.19l0,0C114.12,158.51,114.03,163.26,111.05,166.14z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B2226",
    d: "M181.21,114.09l19.59-21.8c2.77-3.08,2.51-7.82-0.57-10.59l0,0c-3.08-2.77-7.82-2.51-10.59,0.57 l-19.59,21.8c-2.77,3.08-2.51,7.82,0.57,10.59l0,0C173.7,117.43,178.45,117.17,181.21,114.09z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B2226",
    d: "M191.51,129.32l16.67-0.67c4.14-0.17,7.36-3.09,7.19-7.23v0c-0.17-4.14-3.65-7.36-7.79-7.19l-16.67,0.67 c-4.14,0.17-7.36,3.65-7.19,7.79v0C183.88,126.83,187.37,129.49,191.51,129.32z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A373F",
    d: "M195.51,129.26l7.83-0.31c3.83-0.15,6.71-3.47,6.56-7.3v0c-0.17-4.14-3.65-7.36-7.79-7.19l-7.88,0.31 c-3.82,0.15-6.78,3.37-6.63,7.18v0C187.77,126.1,191.36,129.42,195.51,129.26z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A373F",
    d: "M102.07,139.93H83.27c-4.14,0-7.5-3.36-7.5-7.5v0c0-4.14,3.36-7.5,7.5-7.5h18.79c4.14,0,7.5,3.36,7.5,7.5v0 C109.57,136.57,106.21,139.93,102.07,139.93z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A373F",
    d: "M197.04,96.69l-12.56,13.98c-2.77,3.08-7.55,3.16-10.63,0.39l0,0c-3.08-2.77-3.33-7.51-0.57-10.59 l12.56-13.98c2.77-3.08,7.51-3.33,10.59-0.57l0,0C199.52,88.69,199.81,93.61,197.04,96.69z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A373F",
    d: "M107.89,169.18l-5.69,5.49c-2.98,2.87-7.73,2.79-10.6-0.19l0,0c-2.87-2.98-2.79-7.73,0.19-10.6l5.69-5.49 c2.98-2.87,7.73-2.79,10.6,0.19l0,0C110.96,161.56,110.87,166.31,107.89,169.18z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatisfied);
export default __webpack_public_path__ + "static/media/satisfied.4467193442962aa41187d60e46628009.svg";
export { ForwardRef as ReactComponent };